// actionType.js
export const SERVICE_SETTINGS_FETCH_ACTION = "SERVICE_SETTINGS_FETCH_ACTION";
export const SERVICE_SETTINGS_FETCH_SUCCESS = "SERVICE_SETTINGS_FETCH_SUCCESS";
export const SERVICE_SETTINGS_FETCH_ERROR = "SERVICE_SETTINGS_FETCH_ERROR";

export const SERVICE_SETTINGS_SAVE_ACTION = "SERVICE_SETTINGS_SAVE_ACTION";
export const SERVICE_SETTINGS_SAVE_SUCCESS = "SERVICE_SETTINGS_SAVE_SUCCESS";
export const SERVICE_SETTINGS_SAVE_ERROR = "SERVICE_SETTINGS_SAVE_ERROR";
